<template>
  <div class="chapter-list-box">
    <div class="book-info-box">
      <div class="book-cover">
        <NvBookCover :book="book" :show-name="false" />
      </div>
      <div class="book-detail-box">
        <div class="title">{{ book.name }}</div>
        <div class="author">{{ book.author }}</div>
        <div class="chpts" v-if="chptCount">{{ chptCount }} Chapters</div>
      </div>
    </div>
    <van-list class="list-box">
      <van-cell @click="clickItem(item)" v-for="item in chapters" :key="item.id">
        <template #title>
          <span :class="['chpt-title', item === current ? 'chpt-active' : '']">
            {{ item.name }}
          </span>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import NvBookCover from "@/components/NvBookCover";

export default {
  components: {
    NvBookCover
  },
  props: {
    chapters: {
      type: Array,
      default: () => []
    },
    book: {
      type: Object,
      default: () => {}
    },
    current: {
      type: Object
    }
  },
  computed: {
    chptCount() {
      if (this.chapters) {
        return this.chapters.length || 0;
      }
      return null;
    }
  },
  methods: {
    clickItem(chapter) {
      this.$emit("chpt-click", chapter);
    }
  }
};
</script>

<style lang="scss" scoped>
.chapter-list-box {
  .book-info-box {
    padding: 16px;
    display: flex;
    overflow: hidden;
    .book-cover {
      width: 70px;
      height: 85px;
    }
    .book-detail-box {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 10px;
      .title {
        font-size: $fs-s;
        padding-top: 5px;
        font-weight: 500;
      }
      .author {
        font-size: $fs-xs;
        color: $fc-grey;
      }
      .chpts {
        font-size: $fs-xs;
        margin-top: 20px;
      }
    }
  }
  .list-box {
    padding-top: 20px;
    padding-bottom: 20px;
    .chpt-title {
      font-weight: 500;
      font-size: $fs-s;
      color: $fc-black;
    }
    .chpt-active {
      color: $color-main;
    }
  }
}
</style>
